import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import Svg from './BaseIcon';
const CheckboxIcon = ({ className, testId, color, }) => {
    const { colors } = useTheme();
    const iconColor = color ? color : colors.interactive.brandColor;
    return (_jsx(Svg, { className: className, "data-cy": testId, "data-testid": testId, width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", children: _jsx("path", { d: "M11.6666 3.5L5.24998 9.91667L2.33331 7", stroke: iconColor, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) }));
};
export default CheckboxIcon;
//# sourceMappingURL=CheckboxIcon.js.map